import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import firebase from 'firebase/app'
import 'firebase/messaging'
import { notifyEnv } from './config'

const firebaseConfig = {
  apiKey: "AIzaSyBkWAnnBnbrTx_gsedcOLeh2fjToybd5l8",
  authDomain: "v-press-notification.firebaseapp.com",
  projectId: "v-press-notification",
  storageBucket: "v-press-notification.firebasestorage.app",
  messagingSenderId: "994217743299",
  appId: "1:994217743299:web:b0ce7287ebc790953be376"
};

firebase.initializeApp(firebaseConfig)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
